module.exports = __webpack_public_path__ + "img/ruppert_modeldef.a7dc4e2a.png";